import AnchorLink from 'react-anchor-link-smooth-scroll'
import Img from 'gatsby-image'
import React from 'react'
import Link from 'gatsby-link'

import AboutUsComponent from 'components/AboutUsComponent'
import ContactComponent from 'components/ContactComponent'
import CtaComponent from 'components/CtaComponent'
import LeadComponent from 'components/LeadComponent'
import LeadComponentServices from 'components/LeadComponentServices'
import SeoComponent from 'components/SeoComponent'

class ThePage extends React.Component {
  render() {
    return (
      <div>
        <SeoComponent
          title='Softwarepiloten - Agentur für Meteor.js-Programmierung'
          description='Wir planen, designen, programmieren, testen, deployen und messen Ihre Webapplikation oder Mobile-App. In Full-Stack JavaScript undMeteor.Js. Interesse? Dann kontaktieren Sie uns jetzt'
        />
        <LeadComponent
          leadText='WIR ENTWICKELN MIT VIEL LIEBE <i class="fas fa-heart"></i><br/>IHRE SOFTWARE.'
          subText='Wir planen, designen, programmieren, testen, deployen und messen Ihre Webapplikation oder Mobile-App. In <b>Full-Stack JavaScript</b> und Meteor.Js.<br/><br/><b>Benötigen Sie aktuell Unterstützung?</b> Dann schreiben Sie uns doch einfach. Wir beraten Sie gerne unverbindlich und freuen uns auf Sie…'
        />
        <LeadComponentServices imageStore={this.props.imageStore}/>

        <AboutUsComponent imageStore={this.props.imageStore}/>

        <CtaComponent/>

        <div id="fh5co-about-us">
          <div className="container">
            <div className="row" id="about-us">
              <div className="col-md-12 section-heading text-center">
                <h2 className="">GEMEINSAM ZUM ERFOLG</h2>
                <div className="row">
                  <div className="col-md-6 col-md-offset-3">
                    <h3>Von der Konzeption, bis hin zur Full-Stack Programmierung (inklusive automatisierter Tests) und konstanten Analyse des Benutzer-Verhaltens: Mit uns wird Ihr Projekt ein Erfolg.</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Img sizes={this.props.imageStore.meteorJsWebapplikationImage.sizes} alt="Meteor js Webapplikation"/>
        </div>

        <ContactComponent/>

      </div>
    )
  }
}
export default ThePage



// WEBPACK FOOTER //
// ./src/pages/index.js